import { Component } from '@angular/core';

@Component({
  selector: 'app-payg-main',
  templateUrl: './payg-main.component.html',
  styleUrls: ['./payg-main.component.css']
})
export class PaygMainComponent {
  english:boolean=true;
  hindi:boolean=false;
  ngOnInit(): void {
    const storeVal = localStorage.getItem('selectedValue');
    if (storeVal == 'english') {
      this.english = true;
      this.hindi = false;
    }
    if (storeVal == 'hindi') {

      this.english = false;
      this.hindi = true;
    }

  }
}
